import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { authReducer } from "./authApi";
import { toastReducer } from "../store/toastSlice";
import { confirmationDialogReducer } from "../store/confirmationDialogSlice";
import { loaderReducer } from "../store/loaderSlice";
import { userApi } from "../api/userApi";
import { branchApi } from "../api/branchApi";
import { setupListeners } from "@reduxjs/toolkit/query";
import { companyApi } from "./companyApi";
import { reviewApi } from "./reviewApi";

const persistConfig = {
  key: "root",
  storage,
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    toast: toastReducer,
    confirmationDialog: confirmationDialogReducer,
    loader: loaderReducer,
    [userApi.reducerPath]: userApi.reducer,
    [branchApi.reducerPath]: branchApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [reviewApi.reducerPath]: reviewApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required for redux-persist to avoid errors
    })
      .concat(userApi.middleware)
      .concat(branchApi.middleware)
      .concat(companyApi.middleware)
      .concat(reviewApi.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


export const persistor = persistStore(store);
setupListeners(store.dispatch);
